import { Common, ApiBind } from './common.model';
import { PlatformDeliveryType } from '../constants';
import { MultiAdConfig } from './multi-ad-config.model';

export class Platform extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'delivery_type' })
  deliveryType: PlatformDeliveryType;

  @ApiBind({ column: 'sort' })
  sort: number;

  @ApiBind({ column: 'media_type' })
  mediaType: number;

  @ApiBind({ column: 'ad_format_banner' })
  adFormatBanner: boolean;

  @ApiBind({ column: 'ad_format_native' })
  adFormatNative: boolean;

  @ApiBind({ column: 'ad_format_video' })
  adFormatVideo: boolean;

  @ApiBind({ column: 'ad_format_native_to_banner' })
  adFormatNativeToBanner: boolean;

  @ApiBind({ column: 'is_sdk_design_template_native_video' })
  isSdkDesignTemplateNativeVideo: boolean;

  @ApiBind({ column: 'is_emergency_stop' })
  isEmergencyStop: boolean;

  @ApiBind({ column: 'is_pmp' })
  isPMP: boolean;

  @ApiBind({ column: 'is_automatic_ratio' })
  isAutomaticRatio: boolean;

  @ApiBind({ column: 'draw_method_native' })
  drawMethodNative: number;

  @ApiBind({ column: 'draw_method_banner' })
  drawMethodBanner: number;

  @ApiBind({ column: 'draw_method_video' })
  drawMethodVideo: number;

  @ApiBind({ column: 'is_outer_bidding' })
  isOuterBidding: boolean;

  @ApiBind({ column: 'has_topics' })
  hasTopics: boolean;

  @ApiBind({ column: 'use_grpc' })
  useGrpc: boolean;

  @ApiBind({ column: 'is_allox_managed' })
  isAlloxManaged: boolean;
}
